import React, { useContext } from 'react';
import { Avatar, Card, CardActionArea, CardContent, Typography, CardMedia, Box, ButtonBase, Menu, MenuItem } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { apiBaseUrl } from '../utils/Api/Api';
import Pets from '@mui/icons-material/Pets';
import { petsPathTo } from '../utils/Api';
import { PetsContext } from '../contexts/PetsContext';
import SnackbarContext from '../contexts/SnackbarContext';

/* Icons */
import CakeIcon from '@mui/icons-material/Cake';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Today } from '@mui/icons-material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { layoutCardRadius } from '../theme/colors';

const PetCard = ({ pet }) => {
  const navigate = useNavigate();
  const { petsList, setPetsList } = useContext(PetsContext);
  const { openSnackbar, openConfirmDialog } = useContext(SnackbarContext);
  /* Cálculo Niver Pet */
  const PetAge = (birthDate) => {
    if (!birthDate) return false;

    const today = new Date();
    const birthday = new Date(birthDate);

    let years = today.getFullYear() - birthday.getFullYear();
    let months = today.getMonth() - birthday.getMonth();

    if (months < 0 || months === 0 && today.getDate() < birthday.getDate()) {
      years--;
      months += 12;
    }

    if (years >= 1) {
      return `${years} ${years === 1 ? 'ano' : 'anos'}`;
    }

    if (months >= 1) {
      if (today.getDate() >= birthday.getDate()) {
        return `${months} ${months === 1 ? 'mês' : 'meses'}`;
      } else {
        return `${months - 1} ${months - 1 === 1 ? 'mês' : 'meses'}`;
      }
    }

    return "Recém-nascido";
  };

  // Estado para controlar o menu
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  // Função para abrir o menu
  const handleMenuClick = (event) => {
    event.stopPropagation(); // Impede que o clique propague para o card
    setAnchorEl(event.currentTarget);
  };

  // Função para fechar o menu
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleRemovePet = () => {
    handleClose();
    openConfirmDialog(
      'Tem certeza que deseja remover o pet?',
      () => {
        petsPathTo.delete(pet.id).then(() => {
          setPetsList(petsList.filter(p => p.id !== pet.id));
          openSnackbar('Pet removido com sucesso!', 'success');
        });
      }
    );
  };

  const containerFlex = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 1
  }

  const flexCenter = {
    display: 'flex',
    alignItems: 'center'
  }

  const menuItemIcon = {
    width: '16px',
    height: '16px',
    color: '#90A4AE'
  }

  return (
    <Card sx={{ flexGrow: 1 }}>
      <Box sx={{ ...containerFlex, padding: '24px', gap: 2, gridRow: '1 / span 1', gridColumn: '1 / span 1' }}>
        {pet.avatar_url ? (
          <CardMedia
            component="img"
            image={`${apiBaseUrl}/${pet.avatar_url}`}
            sx={{ height: '128px', margin: 'auto', borderRadius: '16px' }}
          />
        ) : (
          <Avatar sx={{ height: '128px', width: '100%', margin: 'auto', borderRadius: '16px' }}>
            <Pets sx={{ width: '32px', height: '32px' }} />
          </Avatar>
        )}
        <CardContent sx={{ ...containerFlex, gap: 1, alignSelf: 'stretch', p: 0, pb: '0 !important' }}>
          <Typography variant="storeName" sx={{ alignSelf: 'stretch', textAlign: 'left', lineHeight: '20px' }}>
            {pet.name}
          </Typography>

          {/* Infos Pet e Botão */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', alignSelf: 'stretch' }}>

            {/* Idade Pet */}
            <Box sx={{ ...flexCenter, gap: 1 }}>
              {
                PetAge(pet.birth_date) &&
                <>
                  <CakeIcon sx={{ color: '#F8963E', width: '16px', height: '16px' }} />
                  <Typography sx={{ fontFamily: 'Nunito', fontSize: '14px', fontWeight: 700, lineHeight: '21px', color: '#546E7A' }}>
                    {PetAge(pet.birth_date)}
                  </Typography>
                </>
              }
            </Box>

            {/* Botão Menu */}
            <ButtonBase
              data-no-shadow="true"
              onClick={handleMenuClick}
              sx={{
                ...flexCenter, p: 0.5, gap: 2, borderRadius: '50%', bgcolor: 'surface.muted', color: 'text.secondary',
                '&:hover': {
                  bgcolor: '#CFD8DC',
                  color: '#263238',
                }
              }}>
              <MoreVertIcon />
            </ButtonBase>

            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              disableScrollLock={true}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              PaperProps={{
                sx: {
                  display: 'inline-flex',
                  alignItems: 'center',
                  borderRadius: layoutCardRadius
                }
              }}
            >
              <MenuItem data-no-shadow="true" sx={{ display: 'flex', gap: 1, alignItems: 'center' }} onClick={() => navigate(`/mypets/${pet.id}/details`)}>
                <EditIcon sx={menuItemIcon} />
                <Typography>Editar pet</Typography>
              </MenuItem>
              <MenuItem data-no-shadow="true" sx={{ display: 'flex', gap: 1, alignItems: 'center' }} onClick={handleRemovePet}>
                <DeleteIcon sx={menuItemIcon} />
                <Typography>Remover pet</Typography>
              </MenuItem>
            </Menu>
          </Box>
        </CardContent>
      </Box>
    </Card>
  );
}

export default PetCard
